<template>
  <div class="input-group">
    <v-row>
      <v-col cols="12" sm="12" md="12" lg="12">
        <v-text-field v-model="node.name" label="Name" hide-details>
        </v-text-field>
      </v-col>
    </v-row>
    <div class="input-title">Transfer to</div>
    <v-row>
      <v-col cols="12" sm="12" md="12" lg="12" class="p-t-0 p-b-0 p-l-25">
        <v-row>
          <v-col cols="12" sm="12" md="12" lg="12" class="d-flex p-t-0 p-b-0">
            <v-radio-group v-model="property.type" hide-details>
              <v-radio
                label="Flow"
                value="flow_ui_id"
                class="margin-radio"
              ></v-radio>
            </v-radio-group>
            <v-select
              class="m-l-20"
              v-model="property.flow_ui_id"
              :items="flows"
              item-text="name"
              item-value="_id"
              :disabled="property.type !== 'flow_ui_id'"
              dense
              hide-details
            ></v-select>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="12" md="12" lg="12" class="d-flex p-t-0 p-b-0">
            <v-radio-group v-model="property.type" hide-details>
              <v-radio
                label="Contact"
                value="contact_id"
                class="margin-radio"
              ></v-radio>
            </v-radio-group>
            <v-select
              class="m-l-20"
              v-model="property.contact_id"
              :items="contacts"
              item-text="label"
              item-value="_id"
              :disabled="property.type !== 'contact_id'"
              dense
              hide-details
            ></v-select>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" sm="12" md="12" lg="12" class="d-flex p-t-0 p-b-0">
            <v-radio-group v-model="property.type" hide-details>
              <v-radio
                label="Number"
                value="number"
                class="margin-radio"
              ></v-radio>
            </v-radio-group>
            <v-text-field
              class="m-l-20"
              v-model="property.number"
              :disabled="property.type !== 'number'"
              @blur="onBlurNumber"
              hide-details
              dense
              @keyup.down="pressDown"
              @keyup.up="pressUp"
              @keydown.enter="onEnter"
              @keydown.tab="pressTab"
            >
            </v-text-field>
          </v-col>
          <!-- === use for Intellisense ===-->
          <intellisense-component
            class="intellisense"
            :input="property.number"
            :drawFlowItems="drawFlowItems"
            :property="'number'"
            :apiForIntellisense="apiForIntellisense"
            @updateIntellisense="updateIntellisense"
            :start="start"
            :eventKey="eventKey"
            @clearSelected="clearSelected"
            @updateInputFromIntellisense="updateInputFromIntellisense"
          />
          <!-- === use for Intellisense  ===-->
          <v-col cols="12" sm="12" md="12" lg="12" class="d-flex p-t-0 p-b-5">
            <div class="label">Name</div>
            <v-text-field
              class="m-l-20"
              v-model="property.number_name"
              :disabled="property.type !== 'number'"
              hide-details
              dense
              @focus="focusTransferNumberName()"
              @keyup.down="pressDown"
              @keyup.up="pressUp"
              @keydown.enter="onEnter"
              @keydown.tab="pressTab"
            >
            </v-text-field>
          </v-col>
          <!-- === use for Intellisense ===-->
          <intellisense-component
            v-if="focusNumberName == true"
            class="intellisense"
            :input="property.number_name"
            :drawFlowItems="drawFlowItems"
            :property="'number_name'"
            :apiForIntellisense="apiForIntellisense"
            :start="start"
            :eventKey="eventKey"
            @clearSelected="clearSelected"
            @updateInputFromIntellisense="updateInputFromIntellisense"
          />
          <!-- === use for Intellisense ===-->
        </v-row>

        <v-row>
          <v-col cols="12" sm="12" md="12" lg="12" class="d-flex p-t-0 p-b-0">
            <v-radio-group v-model="property.type" hide-details>
              <v-radio
                label="Live agent"
                value="live_agent"
                class="margin-radio"
              ></v-radio>
            </v-radio-group>
            <v-select
              class="m-l-20"
              v-model="property.queue_id"
              :items="queues"
              item-text="name"
              item-value="_id"
              :disabled="property.type !== 'live_agent'"
              dense
              hide-details
            ></v-select>
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <div v-if="['contact_id', 'number'].includes(property.type)">
      <div class="input-title mt-4">
        Integration detail
      </div>
      <v-row class="mr-0 mt-2">
        <v-col cols="12" sm="12" md="12" lg="12" class="p-t-0 p-b-0 p-l-25 ">
          <v-row align="center" justify="start">
            <v-checkbox
              :true-value="true"
              hide-details
              label="Integration detail"
              class="margin-checkbox-2"
              v-model="property.use_integration_detail"
              :false-value="false"
            ></v-checkbox>
            <v-text-field
              class="margin-text-field"
              :disabled="!property.use_integration_detail"
              v-model="property.integration_detail_key"
              dense
              hide-details
              @keyup.down="pressDown"
              @keyup.up="pressUp"
              @keydown.enter="onEnter"
              @keydown.tab="pressTab"
              placeholder="Enter Integration detail key"
            ></v-text-field>
          </v-row>
          <!-- === use for Intellisense ===-->
          <intellisense-component
            :input="property.integration_detail_key"
            :drawFlowItems="drawFlowItems"
            :property="'integration_detail_key'"
            :apiForIntellisense="apiForIntellisense"
            :start="start"
            :eventKey="eventKey"
            @clearSelected="clearSelected"
            @updateInputFromIntellisense="updateInputFromIntellisense"
          />
          <!-- === use for Intellisense ===-->
          <v-row align="center" justify="start">
            <v-col
              cols="12"
              sm="12"
              md="12"
              lg="12"
              class="p-t-0 p-b-0 ml-9 pr-9 mt-1"
            >
              <v-textarea
                class="textarea-input mt-2"
                v-model="property.integration_detail_value"
                :disabled="!property.use_integration_detail"
                solo
                hide-details
                rows="3"
                wrap="off"
                @keyup.down="pressDown"
                @keyup.up="pressUp"
                @keydown.enter="onEnter"
                @keydown.tab="pressTab"
                placeholder="Enter JSON object as Integration detail value"
              ></v-textarea>
              <!-- === use for Intellisense ===-->
              <intellisense-component
                :input="property.integration_detail_value"
                :drawFlowItems="drawFlowItems"
                :property="'integration_detail_value'"
                :apiForIntellisense="apiForIntellisense"
                :start="start"
                :eventKey="eventKey"
                @clearSelected="clearSelected"
                @updateInputFromIntellisense="updateInputFromIntellisense"
              />
              <!-- === use for Intellisense ===-->
            </v-col>
          </v-row>
        </v-col>
      </v-row>

      <v-row class="mr-0">
        <v-col cols="12" sm="12" md="12" lg="12" class="p-t-0 p-b-0 p-l-25 ">
          <v-row align="start" justify="start" class="mt-3">
            <v-checkbox
              :true-value="true"
              hide-details
              label="SIP header"
              class="shrink mr-2 margin-checkbox"
              v-model="property.use_sip_header"
              :false-value="false"
            ></v-checkbox>
            <v-col
              cols="12"
              sm="12"
              md="12"
              lg="12"
              class="p-t-0 p-b-0 ml-9 pr-9 mt-1"
            >
              <v-textarea
                class="textarea-input mt-2"
                v-model="property.integration_detail_sip_header"
                :disabled="!property.use_sip_header"
                solo
                hide-details
                rows="3"
                wrap="off"
                @keyup.down="pressDown"
                @keyup.up="pressUp"
                @keydown.enter="onEnter"
                @keydown.tab="pressTab"
                placeholder="Enter JSON object as SIP Header"
              ></v-textarea>
              <!-- === use for Intellisense ===-->
              <intellisense-component
                :input="property.integration_detail_sip_header"
                :drawFlowItems="drawFlowItems"
                :property="'integration_detail_sip_header'"
                :apiForIntellisense="apiForIntellisense"
                :start="start"
                :eventKey="eventKey"
                @clearSelected="clearSelected"
                @updateInputFromIntellisense="updateInputFromIntellisense"
              />
              <!-- === use for Intellisense ===-->
            </v-col>
          </v-row>
        </v-col>
      </v-row>

      <v-row class="mr-0 mt-2">
        <v-col cols="12" sm="12" md="12" lg="12" class="p-t-0 p-b-0 p-l-25 ">
          <v-row align="center" justify="start">
            <v-checkbox
              :true-value="true"
              label="Append to number"
              class="margin-checkbox-2"
              dense
              hide-details
              v-model="property.use_append_to_number"
            ></v-checkbox>
            <v-text-field
              class="margin-text-field"
              :disabled="!property.use_append_to_number"
              v-model="property.integration_detail_append_to_number"
              dense
              hide-details
              @keyup.down="pressDown"
              @keyup.up="pressUp"
              @keydown.enter="onEnter"
              @keydown.tab="pressTab"
            ></v-text-field>
          </v-row>
          <!-- === use for Intellisense ===-->
          <intellisense-component
            :input="property.integration_detail_append_to_number"
            :drawFlowItems="drawFlowItems"
            :property="'integration_detail_append_to_number'"
            :apiForIntellisense="apiForIntellisense"
            :start="start"
            :eventKey="eventKey"
            @clearSelected="clearSelected"
            @updateInputFromIntellisense="updateInputFromIntellisense"
          />
          <!-- === use for Intellisense ===-->
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" sm="12" md="12" lg="12">
          <div class="input-title">Return VXML</div>
          <v-textarea
            v-model="property.vxml"
            class="textarea-input overflow-x m-t-10"
            placeholder="Enter VXML tag"
            solo
            hide-details
            rows="3"
            @keyup.down="pressDown"
            @keyup.up="pressUp"
            @keydown.enter="onEnter"
            @keydown.tab="pressTab"
          ></v-textarea>
          <!-- === use for Intellisense ===-->
          <intellisense-component
            :input="property.vxml"
            :drawFlowItems="drawFlowItems"
            :property="'vxml'"
            :apiForIntellisense="apiForIntellisense"
            :start="start"
            :eventKey="eventKey"
            @clearSelected="clearSelected"
            @updateInputFromIntellisense="updateInputFromIntellisense"
          />
          <!-- === use for Intellisense ===-->
        </v-col>
      </v-row>
    </div>
    <hr class="note-divider" />
    <note-component :node="node" />
  </div>
</template>

<script>
import _ from 'lodash'
import apiFlow from '@/apis/flow'
import apiContact from '@/apis/contact'
import apiQueue from '@/apis/queue'

import NoteComponent from '../../../components/note'
// === use for Intellisense ===
import IntellisenseComponent from '../../../components/intellisense'
// === use for Intellisense ===
export default {
  props: {
    node: Object,
    flowId: String,
    // === use for Intellisense ===
    drawFlowItems: Object,
    apiForIntellisense: Object
    // === use for Intellisense ===
  },
  components: {
    NoteComponent,
    // === use for Intellisense ===
    IntellisenseComponent
    // === use for Intellisense ===
  },
  data() {
    return {
      property: {},
      contacts: [],
      queues: [],
      flows: [],
      focusNumberName: false,
      // === use for Intellisense ===
      start: -1,
      isKeyTab: false,
      eventKey: ''
      // === use for Intellisense ===
    }
  },
  watch: {
    'property.flow_ui_id': {
      handler(value) {
        if (value) {
          const flow = _.find(this.flows, { _id: value })
          if (flow) this.property.flow_ui_name = flow.name
        }
      }
    },
    'property.contact_id': {
      handler(value) {
        if (value) {
          const contact = _.find(this.contacts, { _id: value })
          if (contact) {
            const contactName = (contact.label.split(' (') || [undefined])[0]
            this.property.contact_name = contactName
          }
        }
      }
    },
    'property.queue_id': {
      handler(value) {
        if (value) {
          const queue = _.find(this.queues, { _id: value })
          if (queue) this.property.queue_name = queue.name
        }
      }
    }
  },
  created() {
    this.property = this.node.property
    this.initial()
  },
  methods: {
    async initial() {
      await this.getFlow('voice')
      await this.getContact()
      await this.getQueueVoice()
    },
    // async initial() {
    //   await this.getFlow('voice')
    //   if (this.flows.length > 0 && !this.property.flow_ui_id) {
    //     this.property.flow_ui_id = this.flows[0]._id
    //   }

    //   await this.getContact()
    //   if (this.contacts.length > 0 && !this.property.contact_id) {
    //     this.property.contact_id = this.contacts[0]._id
    //   }

    //   await this.getQueueVoice()
    //   if (this.queues.length > 0 && !this.property.queue_id) {
    //     this.property.queue_id = this.queues[0]._id
    //   }
    // },
    async getContact() {
      try {
        const getContact = await apiContact.getContact({
          sortBy: ['name'],
          sortDesc: [false]
        })
        const { data } = getContact
        this.contacts = []
        for (const obj of data) {
          this.contacts.push({
            _id: obj._id,
            label: `${obj.name} (${obj.phone})`,
            phone: obj.phone
          })
        }
      } catch {}
    },
    async getQueueVoice() {
      try {
        const getQueue = await apiQueue.getQueueVoice()
        const { data } = getQueue
        this.queues = data
      } catch {}
    },
    async getFlow(platform) {
      try {
        const flows = await apiFlow.listFlowUiByPlatform(platform)
        this.flows = _.filter(flows.data, o => {
          return o._id !== this.flowId
        })
      } catch {}
    },
    onBlurNumber() {
      if (this.property.type === 'number' && !this.property.number_name) {
        this.property.number_name = this.property.number
      }
    },
    // === use for Intellisense ===
    focusTransferNumberName() {
      //ใช้สำหรับนับว่าตอนนี้ เราคลิกที่ condition ไหนเพื่อเอาไปทำ intellisense
      this.focusNumberName = true
    },
    updateIntellisense(data) {
      this.node.property.number_name = '$' + data
    },
    pressDown() {
      this.start += 1
      this.eventKey = 'keydown'
    },
    pressUp() {
      this.start -= 1
      this.eventKey = 'keyup'
    },
    pressTab() {
      this.isKeyTab = true
      this.start = -1
    },
    onEnter(e) {
      if (e.keyCode === 13 && this.start > -1) {
        this.eventKey = 'enter'
        this.start = -1
        e.preventDefault()
      }
      this.eventKey = 'enter'
      this.start = -1
    },
    clearSelected() {
      this.start = -1
    },
    updateInputFromIntellisense(property, data) {
      if (property == 'number') {
        this.property.number = data
      } else if (property == 'number_name') {
        this.property.number_name = data
      } else if (property == 'integration_detail_key') {
        this.property.integration_detail_key = data
      } else if (property == 'integration_detail_value') {
        this.property.integration_detail_value = data
      } else if (property == 'integration_detail_sip_header') {
        this.property.integration_detail_sip_header = data
      } else if (property == 'integration_detail_append_to_number') {
        this.property.integration_detail_append_to_number = data
      } else if (property == 'vxml') {
        this.property.vxml = data
      }
    }
    // === use for Intellisense ===
  }
}
</script>

<style scoped lang="scss">
.no-margin-top {
  margin-top: 0px !important;
}
.body-dialog {
  margin: 10px !important;
}
.margin-radio {
  margin-top: 10px;
  width: 100px;
}

.margin-checkbox {
  margin-left: 13px;
}

.margin-checkbox-2 {
  width: 160px;
  margin-left: 13px;
}

.margin-text-field {
  margin-top: 0px;
}

.textarea-input {
  font-size: 14px;
}

.label {
  font-size: 14px;
  margin: 10px 32px 0 32px;
}
.intellisense {
  padding-left: 30%;
  width: 100%;
}
</style>
